export default __webpack_public_path__ + "static/media/un_pw.0a165456.svg";